import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import { isNullOrEmpty } from '../../../../utils/vuex';
import { replaceSpecialChars } from '@/utils/vuex';
import ApiService from '@/services/apiService';
var BRIDGE_TYPES_WITH_CONFIG = ['bridge-IEC-60870-5-104-push'];
export default {
  name: 'CoreDtwinStateEdit',
  props: {
    // the current edited state
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    twinType: {
      type: String,
      required: false,
      default: null
    },
    // is this an edit, create, or readonly?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    otherStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    stateDefinition: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      lclModel: {},
      manualTitleEdit: false,
      manualKeyEdit: false,
      manualUnitEdit: false,
      aggregatedStateValue: '',
      innerFormIsValid: false,
      wholeFormIsValid: false,
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      openApplyConfigModal: false,
      connectors: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    shouldRenderOutboundConfigPanel: function shouldRenderOutboundConfigPanel() {
      if (this.templateContext) {
        return false;
      }

      var hasOutboundConfig = get(this.lclModel, 'properties.outboundConfiguration');
      return hasOutboundConfig || this.connectorsWithStateSetting.length > 0;
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    isGeoState: function isGeoState() {
      return this.isSingleDimensionGeoState || get(this.lclModel, 'properties.valueType') === 'json';
    },
    isSingleDimensionGeoState: function isSingleDimensionGeoState() {
      return (// NOTE: only show single-dimension state selection for existing states now
        // new states should preferrably use an aggregation/json link of geo-coordinates
        this.lclModel.id && /^(lat)|(lon)|(lng).*?/gi.exec(this.lclModel.key) && get(this.lclModel, 'properties.valueType') === 'number'
      );
    },
    keyRules: function keyRules() {
      var _this2 = this;

      return [function (v) {
        return !!v && _this2.isStateKeyUnique(v) || _this2.$i18n_t('DigitalTwin.DigitalTwin.states.keyMustBeUnique');
      }, // eslint-disable-next-line no-useless-escape
      function (v) {
        return !!v && /^([A-Za-z0-9._-])+?$/gi.exec(v) !== null || _this2.$i18n_t('DigitalTwin.DigitalTwin.states.keyText');
      }];
    },
    allowsVisualization: function allowsVisualization() {
      return !this.lclModel.properties.linkGeoCoordinate && (this.lclModel.properties.valueType === 'number' || this.lclModel.properties.valueType === 'boolean' || this.lclModel.properties.valueType === 'string' || this.lclModel.properties.valueType === 'json');
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    copyConfig: function copyConfig() {
      return this.$store.state.app.dtwinStateConfigCopy;
    },
    connectorsWithStateSetting: function connectorsWithStateSetting() {
      return this.connectors.filter(function (b) {
        return BRIDGE_TYPES_WITH_CONFIG.includes(b.type);
      });
    }
  }),
  watch: {
    value: function value() {
      this.lclModel = cloneDeep(this.value);
    },
    isGeoState: function isGeoState() {
      if (this.isGeoState) {
        if (/^(lat).*?/gi.exec(this.lclModel.key) !== null) {
          this.lclModel.properties.geoCoordinateKey = 'lat';
        } else if (/^(lon)|(lng).*?/gi.exec(this.lclModel.key) !== null) {
          this.lclModel.properties.geoCoordinateKey = 'lon';
        }
      }
    }
  },
  created: function created() {
    this.lclModel = cloneDeep(this.value);

    if (this.mode === 'create') {
      this.lclModel = {
        value: {},
        properties: {
          valueType: 'number'
        }
      };
    }

    if (!get(this.lclModel, 'properties.binding')) {
      this.lclModel.properties = Object.assign({}, this.lclModel.properties, {
        binding: {
          type: 'none',
          options: {
            aggregateStateBindingIds: []
          }
        }
      });
    }

    if (!get(this.lclModel, 'properties.outboundConfiguration') || get(this.lclModel, 'properties.outboundConfiguration').length === 0) {
      set(this.lclModel, 'properties.outboundConfiguration', [{}]);
    }

    this.manualTitleEdit = !isNullOrEmpty(this.lclModel.properties.title);
    this.manualKeyEdit = !isNullOrEmpty(this.lclModel.key);
    this.manualUnitEdit = !isNullOrEmpty(this.lclModel.properties.unit);
    this.changedBindingType();
    this.resetVisualProperties();
  },
  mounted: function mounted() {
    var _this3 = this;

    ApiService.getBridgesForTenant(this.tenantId).then(function (bridges) {
      _this3.connectors = bridges;
    }).catch(function (err) {
      console.error(err);
    });
  },
  methods: {
    onTransformerUpdate: function onTransformerUpdate(newTransformer) {
      this.$emit('input', newTransformer);
    },
    resetVisualProperties: function resetVisualProperties() {
      if (this.mode === 'create') {
        this.lclModel.properties.visual = {
          options: {}
        };
      }
    },
    copyStateConfig: function copyStateConfig() {
      this.$store.state.app.dtwinStateConfigCopy = cloneDeep(this.lclModel);
    },
    doApplyConfig: function doApplyConfig(paths) {
      var _this4 = this;

      paths.forEach(function (path) {
        set(_this4.lclModel, path, get(_this4.copyConfig, path, get(_this4.lclModel, path)));
      }); // set the manual edits to true, so that the title/key/unit are not automatically overwritten

      this.manualUnitEdit = true;
      this.lclModel = cloneDeep(this.lclModel);
      this.openApplyConfigModal = false;
    },
    isStateKeyUnique: function isStateKeyUnique(v) {
      var _this5 = this;

      return !this.otherStates.find(function (s) {
        if (_this5.templateContext) {
          return s.key === v && isNaN(_this5.lclModel.indexOfEditedElement);
        }

        s.key === v && s.id !== _this5.lclModel.id;
      });
    },
    setIcon: function setIcon(icon) {
      this.lclModel.properties.faIcon = icon;
    },
    changedBindingType: function changedBindingType() {
      if ( // only update the valueType automatically if the binding-type was changed JUST NOW
      // it changedBindingType is also called on create/init
      get(this.value, 'properties.valueType') === undefined || get(this.value, 'properties.binding.type') !== this.lclModel.properties.binding.type) {
        if (this.lclModel.properties.binding.type === 'random') {
          this.lclModel.properties.valueType = 'number';
        } else if (['aggregate', 'iothub-aggregate', 'virtual-device-aggregate'].indexOf(this.lclModel.properties.binding.type) >= 0) {
          this.lclModel.properties.valueType = 'json';
        }
      }

      this.validateForm();
    },
    validateForm: function validateForm() {
      var _this6 = this;

      this.$nextTick(function () {
        _this6.innerFormIsValid = _this6.$refs.form.validate();
        var sourceEditRefs = get(_this6, '$refs.sourceEdit.$refs') || {};

        if (_this6.lclModel.properties.binding.type === 'bridge') {
          _this6.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.bridgeBindingEdit) && sourceEditRefs.bridgeBindingEdit.formIsValid;
        } else if (_this6.lclModel.properties.binding.type.startsWith('iothub')) {
          _this6.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.iothubBindingEdit) && sourceEditRefs.iothubBindingEdit.formIsValid;
        } else if (_this6.lclModel.properties.binding.type.startsWith('virtual-device')) {
          _this6.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.virtualDeviceBindingEdit) && sourceEditRefs.virtualDeviceBindingEdit.formIsValid;
        } else if (_this6.lclModel.properties.binding.type === 'aggregate') {
          _this6.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.aggregateBindingEdit) && sourceEditRefs.aggregateBindingEdit.aggregateStateLoops === false;
        } else if (_this6.lclModel.properties.visual.type === 'lineChart') {
          _this6.wholeFormIsValid = (!_this6.lclModel.properties.visual.options.minYAxis || !isNaN(parseFloat(_this6.lclModel.properties.visual.options.minYAxis))) && (!_this6.lclModel.properties.visual.options.maxYAxis || !isNaN(parseFloat(_this6.lclModel.properties.visual.options.maxYAxis)));
        } else {
          _this6.wholeFormIsValid = true;
        }

        _this6.wholeFormIsValid = _this6.wholeFormIsValid && (!_this6.$refs.stateTransformerComp || _this6.$refs.stateTransformerComp.formIsValid);
        _this6.wholeFormIsValid = _this6.wholeFormIsValid && _this6.innerFormIsValid && !isNullOrEmpty(_this6.$refs.stateVisualComp) && _this6.$refs.stateVisualComp.formIsValid;
      });
    },
    titleEntered: function titleEntered() {
      this.manualTitleEdit = true;

      if (!this.manualKeyEdit) {
        this.setKeyFromTitle(this.lclModel.properties.title);
      }

      this.validateForm();
    },
    setKeyFromTitle: function setKeyFromTitle(title) {
      this.lclModel.key = replaceSpecialChars(title);
    },
    keyEntered: function keyEntered() {
      this.manualKeyEdit = true;
      this.validateForm();
    },
    // ----
    // NIOTA OR IOTHUB
    // ----
    noPermissionError: function noPermissionError(error) {
      this.close(error || 'NOT AUTHORIZED FOR THIS STATE');
    },
    bridgeBindingChanged: function bridgeBindingChanged(val) {
      var variable = val.variable;
      var valueType = val.valueType;
      var value = val.value;

      if (!!variable) {
        if (!this.manualTitleEdit || isNullOrEmpty(this.lclModel.properties.title)) {
          this.lclModel.properties.title = variable;
        }

        if (isNullOrEmpty(this.lclModel.key)) {
          this.setKeyFromTitle(variable);
        }

        if (!!valueType && (!this.manualUnitEdit || isNullOrEmpty(this.lclModel.properties.unit))) {
          this.lclModel.properties.unit = valueType;
        }

        if (!!value) {
          this.lclModel.value.value = value;
        }

        this.lclModel = cloneDeep(this.lclModel);
      }

      this.validateForm();
    },
    // -----
    // AGGREGATE
    // -----
    aggregatedStateValueChanged: function aggregatedStateValueChanged(aggregatedStateValue) {
      this.aggregatedStateValue = aggregatedStateValue;
    },
    handleSubmit: function handleSubmit() {
      this.$refs.stateValueComp.saveState();
      var sourceEditRefs = get(this, '$refs.sourceEdit.$refs') || {};

      if (this.lclModel.properties.binding.type === 'bridge') {
        if (sourceEditRefs.bridgeBindingEdit && sourceEditRefs.bridgeBindingEdit.saveState) {
          sourceEditRefs.bridgeBindingEdit.saveState();
        }
      } else if (this.lclModel.properties.binding.type.startsWith('iothub')) {
        sourceEditRefs.iothubBindingEdit.saveState();
      } else if (this.lclModel.properties.binding.type.startsWith('virtual-device')) {
        sourceEditRefs.virtualDeviceBindingEdit.saveState();
      } else if (this.lclModel.properties.binding.type === 'aggregate') {
        sourceEditRefs.aggregateBindingEdit.saveState();
      }

      if (this.$refs.stateTransformerComp) {
        this.$refs.stateTransformerComp.saveState();
      }

      var cloneData = cloneDeep(this.lclModel);
      cloneData.properties.outboundConfiguration = cloneData.properties.outboundConfiguration.filter(function (config) {
        return config.connectorId;
      });
      this.$emit('save', cloneData);
    },
    close: function close(errorMessage) {
      this.$emit('close', errorMessage);
    }
  }
};